import React, { useState, useEffect, useMemo } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { makeStyles } from '@material-ui/core/styles';
import {
   Paper,
   Box,
   Button,
   IconButton,
   Tooltip,
   Divider,
   Menu,
   MenuItem,
   Radio,
   Typography,
} from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TitleLabel, LabelInputSpin } from '../../../../Element/LabelInputForm';
import { AlertLabel, Input } from '../../../../../assets/styled/Element';
import {
   faCheckSquare,
   faAlignLeft,
   faDotCircle,
   faSignOutAlt,
   faChevronCircleDown,
   faSortNumericDown,
} from '@fortawesome/free-solid-svg-icons';
import {
   faCircle,
   faPlus,
   faCopy,
   faEllipsisH,
   faTrashAlt as trashRegular,
} from '@fortawesome/pro-regular-svg-icons';
import { faTrashAlt } from '@fortawesome/pro-duotone-svg-icons';
import SwitchIOS from '../../../../Switch/SwitchIOS';
import { MySelect } from '../../../../Select/Select';
import ImageUpload from './../ImageUpload';

const useStyles = makeStyles((theme) => ({
   containerPaper: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      alignItems: 'center',
   },
   paper: {
      // backgroundColor: theme.palette.background.paper,
      // padding: theme.spacing(2, 4, 3),
      // backgroundColor: "#fff",
      // width: "100%",
      borderRadius: '7.5px',
      // maxHeight: "95vh",
      // overflow: "auto",
      margin: '0 24px',
      width: '80%',
   },
   section: {
      height: '25px',
      backgroundColor: '#ffd657',
      padding: '0 10px',
      borderRadius: '5px',
      display: 'flex',
      alignItems: 'center',
      fontSize: '16px',
   },
}));

const QuestionAnswerComponent = ({
   value,
   onValueChange,
   totalQuestions,
   onRemoveQuestion,
   onCopyQuestion,
}) => {
   const classes = useStyles();

   const {
      handleSubmit,
      control,
      register,
      errors,
      watch,
      setValue,
      getValues,
   } = useForm({
      defaultValues: {},
   });

   const [myMenu, setMyMenu] = useState(null);

   const mapOptionFormatDetail = [
      {
         value: value.choiceMode,
         label: value.choiceModeDesc,
         icon:
            value.choiceMode == 1
               ? faDotCircle
               : value.choiceMode == 2
               ? faCheckSquare
               : value.choiceMode == 3
               ? faAlignLeft
               : value.choiceMode == 5
               ? faChevronCircleDown
               : faSortNumericDown,
      },
   ];

   const mapOptionTypeChoieDetail = [
      {
         value: value.inputType,
         label: value.inputType == 3 ? 'Text & Image' : 'Text',
      },
   ];

   const optionsQuestionFormat = [
      {
         value: 1,
         label: 'Single Choice',
         icon: faDotCircle,
      },
      {
         value: 2,
         label: 'Multiple Choice',
         icon: faCheckSquare,
      },
      {
         value: 3,
         label: 'Text Area',
         icon: faAlignLeft,
      },
      {
         value: 4,
         label: 'Rank',
         icon: faSortNumericDown,
      },
      {
         value: 5,
         label: 'Dropdown',
         icon: faChevronCircleDown,
      },
   ];

   const optionsTypeChoiceSingle = [
      { value: 1, label: 'Text' },
      { value: 3, label: 'Text & Image' },
   ];

   const optionsTypeChoiceMultiple = [{ value: 1, label: 'Text' }];

   const options = {
      optionId: 0,
      optionTh: '',
      optionEn: '',
      otionImageUrl: '',
      nextStepType: 1,
      nextSectionId: 2,
      nextQuestionId: 3,
      isDelete: false,
   };

   const nextStepOptionList =
      value?.nextStepType === 3
         ? value?.nextStepOption
              ?.filter((opt) => opt.nextStepType === 3)
              .map((opt) => ({
                 value: opt.nextStepType,
                 label: opt.nextStepDesc,
                 nextQuestionId: opt.nextQuestionId,
                 nextSectionId: opt.nextSectionId,
              })) || []
         : value?.nextStepType === 4
         ? value?.nextStepOption
              ?.filter((opt) => opt.nextStepType === 4)
              .map((opt) => ({
                 value: opt.nextStepType,
                 label: opt.nextStepDesc,
                 nextQuestionId: opt.nextQuestionId,
                 nextSectionId: opt.nextSectionId,
              })) || []
         : [];

   // สร้างตัวแปร options จาก nextStepOptionOfOption
   const nextStepOptionOfOptionList =
      value?.nextStepOptionOfOption?.map((opt) => ({
         value: opt.nextStepType,
         label: opt.nextStepDesc,
         nextQuestionId: opt.nextQuestionId,
         nextSectionId: opt.nextSectionId,
      })) || [];

   const optionDefaultOption = value
      ? [
           {
              value: value.nextStepType,
              label: value.nextStepDesc,
           },
        ]
      : [];

   const optionDefaultOptionOfOption =
      value?.option?.map((opt) => ({
         value: opt.nextStepType,
         label: opt.nextStepDesc,
      })) || [];

   const handleQuestionName = (event) => {
      const newValue = event.target.value;
      onValueChange({
         ...value,
         quesNameTh: newValue,
      });
   };

   const handleQuestionDescription = (event) => {
      const newValue = event.target.value;

      onValueChange({
         ...value,
         quesDescTh: newValue,
      });
   };

   const [typeChoiceOptions, setTypeChoiceOptions] = useState(
      optionsTypeChoiceSingle,
   );

   const handleQuestionFormatChange = (selected) => {
      if (!selected?.value) return null;

      // Create a single default option with empty values
      const defaultOption = {
         optionId: 0,
         optionTh: '',
         optionEn: '',
         otionImageUrl: '',
         nextStepType: 1,
         nextSectionId: 2,
         nextQuestionId: 3,
         isDelete: false,
      };

      const updates = {
         questionFormat: {
            id: selected.value,
            value: selected.label,
         },
      };

      if (selected.value === 1 || selected.value === 2) {
         setTypeChoiceOptions(optionsTypeChoiceSingle);
         updates.choiceType = {
            id: optionsTypeChoiceSingle[0].value,
            value: optionsTypeChoiceSingle[0].label,
         };
         setValue('choiceType', optionsTypeChoiceSingle[0]);
      } else {
         setTypeChoiceOptions(optionsTypeChoiceMultiple);
         updates.choiceType = {
            id: optionsTypeChoiceMultiple[0].value,
            value: optionsTypeChoiceMultiple[0].label,
         };
         setValue('choiceType', optionsTypeChoiceMultiple[0]);
      }

      // Reset the form with a single empty option
      onValueChange({
         ...value,
         choiceMode: updates.questionFormat.id,
         choiceModeDesc: updates.questionFormat.value,
         inputType: updates.choiceType.id,
         inputTypeDesc: updates.choiceType.value,
         option: [defaultOption], // Reset to single empty option
         answerMin: 0, // Reset min/max if they exist
         answerMax: 0,
      });

      return selected;
   };

   const handleMinMaxChoice = (event) => {
      if (!event?.target) return;

      const { name, value: inputValue } = event.target;
      const activeOptions = value.option.filter((opt) => !opt.isDelete);

      // แปลงค่าที่ป้อนให้เป็นตัวเลข
      let numericValue = Number(inputValue.replace(/[^0-9]/g, ''));

      // ถ้า isRequired เป็น true ให้ค่าต่ำสุดเป็น 1
      if (value.isRequired && numericValue < 1) {
         numericValue = 1;
      }

      // จำกัดค่าไม่ให้เกินจำนวนตัวเลือกที่ยังคงอยู่
      numericValue = Math.min(numericValue, activeOptions.length);

      onValueChange({
         ...value,
         [name]: numericValue,
      });
   };

   const updateQuestionInput = (field, newValue, index) => {
      const updatedOptions = value.option.map((option, updateIndex) =>
         updateIndex === index ? { ...option, [field]: newValue } : option,
      );

      onValueChange({
         ...value,
         option: updatedOptions,
      });
   };

   const handleAddOption = () => {
      onValueChange({
         ...value,
         option: [...value.option, options],
      });
   };

   const handleRemoveOption = (index) => {
      const updatedOptions = value.option.map((item, i) =>
         i === index ? { ...item, isDelete: true } : item,
      );

      onValueChange({
         ...value,
         option: updatedOptions,
      });
   };

   const handleUploadeChange = (file, field, index) => {
      const updatedOptions = value.option.map((option, i) =>
         i === index ? { ...option, [field]: file.url } : option,
      );

      onValueChange({
         ...value,
         option: updatedOptions,
      });
   };

   const handleNextStepQuestion = (selected, optionId) => {
      onValueChange({
         ...value,
         nextStepType: selected.value,
         nextQuestionId: selected.nextQuestionId || 0,
         nextSectionId: selected.nextSectionId || 0,
      });
   };

   const handleNextStepByChoice = (selected, optionIndex) => {
      // console.log("selected by choice: ", selected);

      const updatedOptions = value.option.map((opt, index) =>
         index === optionIndex
            ? {
                 ...opt,
                 nextStepType: selected.value,
                 next_QuestionId: selected.nextQuestionId || 0,
                 next_SectionId: selected.nextSectionId || 0,
              }
            : opt,
      );

      onValueChange({
         ...value,
         option: updatedOptions, // อัปเดตเฉพาะ option ที่มีการเปลี่ยนแปลง
      });
   };

   const handleIsRequired = (event) => {
      onValueChange({
         ...value,
         isRequired: event,
      });
   };

   // ฟังก์ชันเปิดเมนู
   const handleMyMenuClick = (event) => {
      setMyMenu(event.currentTarget);
   };

   // ฟังก์ชันปิดเมนู
   const handleMyMenuClose = () => {
      setMyMenu(null);
   };

   // ฟังก์ชันเลือกเมนูและปิด
   const handleMenuItemSelect = (values, label) => {
      onValueChange({
         ...value,
         nextStepType: values,
         nextStepDesc: label,
      });

      handleMyMenuClose();
   };

   useEffect(() => {
      const activeOptionsCount = value.option.filter(
         (opt) => !opt.isDelete,
      ).length;
      let updatedValue = { ...value };
      let needsUpdate = false;

      // ตรวจสอบ answerMin
      if (value.answerMin > activeOptionsCount) {
         updatedValue.answerMin = activeOptionsCount;
         needsUpdate = true;
      }

      // ถ้า isRequired เป็น true และ answerMin น้อยกว่า 1
      if (value.isRequired && value.answerMin < 1) {
         updatedValue.answerMin = 1;
         needsUpdate = true;
      }

      // ตรวจสอบ answerMax
      if (value.answerMax > activeOptionsCount) {
         updatedValue.answerMax = activeOptionsCount;
         needsUpdate = true;
      }

      // ถ้า isRequired เป็น true และ answerMax น้อยกว่า 1
      if (value.isRequired && value.answerMax < 1) {
         updatedValue.answerMax = 1;
         needsUpdate = true;
      }

      // อัพเดทค่าเมื่อจำเป็น
      if (needsUpdate) {
         onValueChange(updatedValue);
      }
   }, [value.option, value.isRequired, onValueChange]);

   return (
      <div className={classes.containerPaper}>
         {/* ส่วนของการตั้งชื่อคำถาม, รายละเอียดคำถาม และรูปแบบคำถามกับรูปแบบ Choice */}
         <Paper
            className={classes.paper}
            // style={{ marginBottom: "24px" }}
         >
            <Box padding={'16px 32px 24px'}>
               {/* ชื่อคำถาม และรายละเอียดคำถาม */}
               <Box
                  display={'flex'}
                  width={'100%'}
                  gridGap={'16px'}
                  marginBottom={2}
               >
                  {/* ชื่อคำถาม */}
                  <Box width={'65%'}>
                     <Box mb={1}>
                        <Box>
                           <TitleLabel Fs={'20px'}>ชื่อคำถาม</TitleLabel>
                        </Box>
                        <Input
                           name={'quesNameTh'}
                           placeholder={'ชื่อคำถาม'}
                           value={value.quesNameTh}
                           onChange={handleQuestionName}
                        />
                     </Box>
                     {/* รายละเอียดคำถาม */}
                     <Box>
                        <Box>
                           <TitleLabel Fs={'20px'}>รายละเอียดคำถาม</TitleLabel>
                        </Box>
                        <Input
                           name={'questionDescription'}
                           placeholder={'รายละเอียดคำถาม'}
                           value={value.quesDescTh}
                           onChange={handleQuestionDescription}
                        />
                     </Box>
                  </Box>
                  {/* รูปแบบคำถามกับรูปแบบ Choice' */}
                  <Box
                     display={'flex'}
                     flexDirection={'column'}
                     gridGap={'10px'}
                     width={'35%'}
                  >
                     {/* รูปแบบคำถาม */}
                     <Box>
                        <TitleLabel Fs={'20px'}>รูปแบบคำถาม</TitleLabel>
                        <Controller
                           as={
                              <MySelect
                                 options={optionsQuestionFormat}
                                 placeholder={'เลือกรูปแบบคำถาม'}
                                 closeMenuOnSelect
                                 isClearable={false}
                              />
                           }
                           onChange={([selected]) =>
                              handleQuestionFormatChange(selected)
                           }
                           name='questionFormat'
                           control={control}
                           defaultValue={
                              value
                                 ? mapOptionFormatDetail
                                 : optionsQuestionFormat[0]
                           }
                        />
                     </Box>
                     {/* รูปแบบ Choice' */}

                     <Box>
                        <TitleLabel Fs={'20px'}>รูปแบบ Choice</TitleLabel>
                        <Controller
                           as={
                              <MySelect
                                 options={typeChoiceOptions}
                                 placeholder={'เลือกรูปแบบ Choice'}
                                 closeMenuOnSelect
                                 isClearable={false}
                              />
                           }
                           rules={{ required: true }}
                           defaultValue={
                              value
                                 ? mapOptionTypeChoieDetail[0]
                                 : typeChoiceOptions[0]
                           }
                           onChange={([selected]) => {
                              onValueChange({
                                 ...value,
                                 inputType: selected.value,
                                 inputTypeDesc: selected.label,
                              });
                              return selected;
                           }}
                           name='choiceType'
                           control={control}
                        />
                     </Box>
                  </Box>
               </Box>
               {value.choiceMode == 2 && (
                  <Box>
                     <Divider />
                     <Box
                        display={'flex'}
                        gridGap={'10px'}
                        margin={'16px 0 16px'}
                     >
                        <Box
                           width={'50%'}
                           display={'flex'}
                           alignItems={'center'}
                           gridGap={'10px'}
                        >
                           <Box flexShrink={0}>
                              <TitleLabel Fs={'18px'}>
                                 เลือกได้มากสุด
                              </TitleLabel>
                           </Box>
                           <Input
                              name={'answerMax'}
                              placeholder={'เลือกได้มากสุด'}
                              value={value.answerMax}
                              onChange={handleMinMaxChoice}
                              style={{ height: '20px', textAlign: 'center' }}
                           />

                           <Box>
                              <TitleLabel Fs={'18px'}>คำถาม</TitleLabel>
                           </Box>
                        </Box>
                        <Box borderLeft={'1px solid black'}></Box>
                        <Box
                           width={'50%'}
                           display={'flex'}
                           alignItems={'center'}
                           gridGap={'10px'}
                        >
                           <Box flexShrink={0}>
                              <TitleLabel Fs={'18px'}>
                                 เลือกได้น้อยสุด
                              </TitleLabel>
                           </Box>
                           <Input
                              name={'answerMin'}
                              placeholder={'เลือกได้น้อยสุด'}
                              value={value.answerMin}
                              onChange={handleMinMaxChoice}
                              style={{ height: '20px', textAlign: 'center' }}
                           />
                           <Box>
                              <TitleLabel Fs={'18px'}>คำถาม</TitleLabel>
                           </Box>
                        </Box>
                     </Box>
                  </Box>
               )}
               <Divider />
               {/* ส่วนของการเพิ่มคำถามและลบคำถาม  */}
               <Box mt={2}>
                  {value.option.map(
                     (option, optionIndex) =>
                        !option.isDelete && (
                           <Box
                              // key={option.optionId}
                              display='flex'
                              justifyContent='space-between'
                              mt={1}
                              gridGap='25px'
                              alignItems={
                                 value.choiceMode == 2 && value.inputType == 3
                                    ? 'flex-start'
                                    : 'center'
                              }
                           >
                              {/* ช่องคำถาม */}
                              <Box
                                 display={'flex'}
                                 flexDirection={'column'}
                                 width='60%'
                              >
                                 {!option.isDelete && (
                                    <Box
                                       display='flex'
                                       alignItems='center'
                                       gridGap='10px'
                                    >
                                       <FontAwesomeIcon
                                          icon={faCircle}
                                          style={{
                                             fontSize: '18px',
                                             color: '#d7d7d7',
                                          }}
                                       />
                                       <Input
                                          placeholder='Answer Name'
                                          value={option.optionTh}
                                          onChange={(event) =>
                                             updateQuestionInput(
                                                'optionTh',
                                                event.target.value,
                                                optionIndex,
                                             )
                                          }
                                       />
                                    </Box>
                                 )}

                                 {value.inputType == 3 && (
                                    <Box
                                       marginLeft={'29px'}
                                       marginTop={'10px'}
                                       width={'60%'}
                                    >
                                       <ImageUpload
                                          id={`image-${optionIndex}`}
                                          width='300px'
                                          height='300px'
                                          imageUrl={option.optionImageUrl}
                                          onUploadChange={(file) =>
                                             handleUploadeChange(
                                                file,
                                                'optionImageUrl',
                                                optionIndex,
                                             )
                                          }
                                       />
                                    </Box>
                                 )}
                              </Box>

                              {value.nextStepType == 5 && (
                                 <Box width={'40%'}>
                                    <Controller
                                       as={
                                          <MySelect
                                             options={
                                                nextStepOptionOfOptionList
                                             }
                                             placeholder={'Setting By Choice'}
                                             closeMenuOnSelect
                                             isClearable={false}
                                             // menu={"top"}
                                          />
                                       }
                                       onChange={([selected]) =>
                                          handleNextStepByChoice(
                                             selected,
                                             optionIndex,
                                          )
                                       }
                                       name='questionFormat'
                                       control={control}
                                       defaultValue={
                                          value?.option?.[0]?.nextStepType
                                             ? optionDefaultOptionOfOption ||
                                               null
                                             : null
                                       }
                                    />
                                 </Box>
                              )}

                              {/* ปุ่มลบคำถาม */}
                              {value.option.filter((opt) => !opt.isDelete)
                                 .length > 1 && (
                                 <Tooltip title='ลบคำถาม'>
                                    <IconButton
                                       aria-label='ลบคำถาม'
                                       onClick={() =>
                                          handleRemoveOption(optionIndex)
                                       }
                                    >
                                       <FontAwesomeIcon
                                          color='#ed1c24'
                                          icon={faTrashAlt}
                                          style={{ fontSize: '18px' }}
                                       />
                                    </IconButton>
                                 </Tooltip>
                              )}
                           </Box>
                        ),
                  )}
               </Box>

               {/* ส่วนของการเพิ่มคำถามและตัวเลือกของคำถาม  */}
               <Box
                  display={'flex'}
                  justifyContent={'space-between'}
                  alignItems={'center'}
                  marginTop={'25px'}
               >
                  {/* ปุ่มเพิ่มคำถาม */}
                  <Button
                     variant={'contained'}
                     startIcon={
                        <FontAwesomeIcon
                           icon={faPlus}
                           style={{ fontSize: '16px' }}
                        />
                     }
                     style={{
                        backgroundColor: '#ed008a',
                        color: '#ffffff',
                        height: '35px',
                     }}
                     onClick={() => {
                        handleAddOption();
                     }}
                  >
                     Add Answer
                  </Button>

                  <Box display={'flex'} gridGap={'5px'}>
                     {/* ปุ่ม required คำถาม */}
                     <Box
                        display={'flex'}
                        gridGap={'5px'}
                        alignItems={'center'}
                        paddingRight={'12px'}
                     >
                        <TitleLabel Fs={'16px'}>Require</TitleLabel>
                        <SwitchIOS
                           activeText='O'
                           inactiveText='-'
                           width='48px'
                           checked={value.isRequired}
                           onChange={handleIsRequired}
                        />
                     </Box>

                     {/* ปุ่ม copy คำถาม */}
                     <Tooltip title='คัดลอกคำถาม'>
                        <IconButton
                           aria-label='คัดลอกคำถาม'
                           onClick={onCopyQuestion}
                        >
                           <FontAwesomeIcon
                              color='#5584F3'
                              icon={faCopy}
                              style={{ fontSize: '18px' }}
                           />
                        </IconButton>
                     </Tooltip>

                     {/* ปุ่มลบคำถาม */}
                     {totalQuestions > 1 && (
                        <Tooltip title='ลบคำถาม'>
                           <IconButton
                              aria-label='ลบคำถาม'
                              onClick={onRemoveQuestion}
                           >
                              <FontAwesomeIcon
                                 color='#ed1c24'
                                 icon={trashRegular}
                                 style={{ fontSize: '18px' }}
                              />
                           </IconButton>
                        </Tooltip>
                     )}

                     {/* ปุ่ม เพิ่มเติม */}
                     <Tooltip title='เพิ่มเติม' onClick={handleMyMenuClick}>
                        <IconButton aria-label='เพิ่มเติม'>
                           <FontAwesomeIcon
                              color='#000000'
                              icon={faEllipsisH}
                              style={{ fontSize: '18px' }}
                           />
                        </IconButton>
                     </Tooltip>

                     {/* menu ปุ่มเพิ่มเติม */}
                     <Menu
                        id='simple-menu'
                        anchorEl={myMenu}
                        keepMounted
                        open={Boolean(myMenu)}
                        onClose={handleMyMenuClose}
                        anchorOrigin={{
                           vertical: 'top',
                           horizontal: 'right',
                        }}
                        transformOrigin={{
                           vertical: 'top',
                           horizontal: 'bottom',
                        }}
                     >
                        <TitleLabel
                           Fs={'22px'}
                           style={{ fontWeight: 'bold', paddingLeft: '22px' }}
                        >
                           Question and Choice
                        </TitleLabel>

                        {[
                           {
                              value: 2,
                              label: 'Continue to Next Question',
                           },
                           {
                              value: 3,
                              label: 'Go to Other Questions',
                           },
                           { value: 4, label: 'Go to Other Section' },
                           { value: 5, label: 'Setting by Choice' },
                           { value: 6, label: 'Submit Form' },
                        ].map((item) => (
                           <MenuItem
                              key={item.value}
                              onClick={() =>
                                 handleMenuItemSelect(item.value, item.label)
                              }
                           >
                              <Box display='flex' alignItems='center'>
                                 <Radio
                                    checked={value.nextStepType === item.value}
                                    value={item.value}
                                    name='menu-radio'
                                    inputProps={{ 'aria-label': item.label }}
                                 />

                                 <Typography style={{ fontSize: '20px' }}>
                                    {item.label}
                                 </Typography>
                              </Box>
                           </MenuItem>
                        ))}
                     </Menu>
                  </Box>
               </Box>

               {value.nextStepType == 3 && (
                  <Box
                     width={'100%'}
                     display={'flex'}
                     justifyContent={'flex-end'}
                  >
                     <Box width={'40%'}>
                        <Controller
                           as={
                              <MySelect
                                 options={nextStepOptionList}
                                 placeholder={'Go To other Questions'}
                                 closeMenuOnSelect
                                 isClearable={false}
                                 menu={'top'}
                              />
                           }
                           onChange={([selected]) =>
                              handleNextStepQuestion(selected)
                           }
                           name='questionFormat'
                           control={control}
                           defaultValue={value ? optionDefaultOption : null}
                        />
                     </Box>
                  </Box>
               )}

               {value.nextStepType == 4 && (
                  <Box
                     width={'100%'}
                     display={'flex'}
                     justifyContent={'flex-end'}
                  >
                     <Box width={'40%'}>
                        <Controller
                           as={
                              <MySelect
                                 options={nextStepOptionList}
                                 placeholder={'Go To other Section'}
                                 closeMenuOnSelect
                                 isClearable={false}
                                 menu={'top'}
                              />
                           }
                           onChange={([selected]) =>
                              handleNextStepQuestion(selected)
                           }
                           name='questionFormat'
                           control={control}
                           defaultValue={value ? optionDefaultOption : null}
                        />
                     </Box>
                  </Box>
               )}
            </Box>
         </Paper>
      </div>
   );
};

export default QuestionAnswerComponent;
